import { useDeviceType, UiKitRoot } from '@cian/ui-kit';
import * as style from './styles.css';
import { clsx } from 'clsx';

interface IFormBannerProps {
  form: JSX.Element;
}

export const FormBanner: React.FC<IFormBannerProps> = ({ form }) => {
  const device = useDeviceType();

  return (
    <div className={style['light-theme-wrapper']}>
      <UiKitRoot theme="light">
        <div className={clsx(style['container'], style[device])}>
          <div className={clsx(style['wrapper'], style[device])}>{form}</div>
        </div>
      </UiKitRoot>
    </div>
  );
};
